import { Pipe, PipeTransform } from '@angular/core';

import { StatusAkceptacji } from '@interfaces/dyplomowanie/enums/status-akceptacji.enum';

@Pipe({
  name: 'acceptProtocolStatus',
})
export class AcceptProtocolStatusPipe implements PipeTransform {
  transform(status: StatusAkceptacji): string {
    switch (status) {
      case StatusAkceptacji.KopiaRobocza:
        return 'Kopia robocza';
      case StatusAkceptacji.PrzekazanoDoAkceptacji:
        return 'Kopia robocza';
      case StatusAkceptacji.NieZaakceptowano:
        return 'Nie zaakceptowano';
      case StatusAkceptacji.Zaakceptowano:
        return 'Zaakceptowano';
    }
  }
}
